import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import 'react-phone-number-input/style.css';
import styles from '../../../EditDevice/editDevice.styles.js';
import moment from 'moment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { isEmpty } from 'lodash';
import IconButton from '../../../components/IconButton.jsx';
import { ICON_BUTTON_TYPE } from '../../../constants/index.js';

const useStyles = makeStyles()(styles);

function EventDetails({ closeModal, event }) {
  const { classes } = useStyles();

  return (
    <div className={classes.paper} style={{ width: '350px' }}>
      <Grid container item direction="row" justify="space-between" alignItems="center" className={classes.header}>
        <Grid item>
          <div className="event-popup-type">{event?.type}</div>
        </Grid>
        <Grid item className={classes.closeIcon} onClick={closeModal}>
          <IconButton type={ICON_BUTTON_TYPE.close} />
        </Grid>
      </Grid>
      <Grid container>
        <h3>{event?.title || ''}</h3>
      </Grid>
      <Grid container>
        <div className="event-popup-pill">
          <CalendarMonthIcon style={{ fontSize: '14px', marginRight: '3px' }} />
          {moment(event?.start).format('D MMMM YYYY')}
        </div>
        <div className="event-popup-pill">
          <AccessTimeIcon style={{ fontSize: '14px', marginRight: '3px' }} />
          {moment(event?.start).format('hh:mm A')} - {moment(event?.end).format('hh:mm A')}
        </div>
      </Grid>
      {event?.location && (
        <Grid container>
          <div className="event-popup-pill">
            <FmdGoodIcon style={{ fontSize: '14px', marginRight: '3px' }} />
            {event?.location || "St Patrick's Mental Health Services"}
          </div>
        </Grid>
      )}
      <Grid container>
        <p style={{ fontSize: '13px' }}>{event?.description || ''}</p>
      </Grid>
      {!isEmpty(event?.userDetails?.userInfo?.firstName) && (
        <Grid container>
          <p style={{ fontSize: '13px' }}>
            Assignee: {event?.userDetails?.userInfo?.firstName} {event?.userDetails?.userInfo?.lastName || ''}
          </p>
        </Grid>
      )}
    </div>
  );
}

export default EventDetails;
